// removed by extract-text-webpack-plugin
module.exports = {"signin-box":"signin-box","register-box-body":"register-box-body","forgot-password":"forgot-password","register-link":"register-link"};


//////////////////
// WEBPACK FOOTER
// ./components/signin/_SigninForm.scss
// module id = ./components/signin/_SigninForm.scss
// module chunks = 0